import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { MetaData } from "../../models/Seo";
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Meta data form
 */

export class MetaDataForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.fields = [{
      label: 'Ссылка',
      name: 'url'
    }, {
      label: 'Тип',
      name: 'entity',
      type: BaseForm.TYPES.DROPDOWN,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(MetaData.entitiesTitles)
        }
      }
    }, {
      label: 'Сущность',
      name: 'entityId'
    }, {
      label: 'Заголовок',
      name: 'title'
    }, {
      label: 'H1',
      name: 'h1'
    }, {
      label: 'H2',
      name: 'h2'
    }, {
      label: 'H3',
      name: 'h3'
    }, {
      label: 'Описание',
      name: 'description',
      type: BaseForm.TYPES.EDITOR
    }, {
      label: 'Ключевые слова',
      name: 'keywords'
    }, {
      label: 'Каноническая ссылка',
      name: 'canonical'
    }];
    this.dispatchCreateForm = DispatchSelector.seo.create;
    this.dispatchUpdateForm = DispatchSelector.seo.update;
    this.responseCreateState = StateSelector.seo.create;
    this.responseUpdateState = StateSelector.seo.update;
  }

}